/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Heading_ItalicInputs */

const et_faq_heading_italic = /** @type {(inputs: Faq_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küsimused`)
};

const en_faq_heading_italic = /** @type {(inputs: Faq_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Faq_Heading_ItalicInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_heading_italic = /** @type {((inputs?: Faq_Heading_ItalicInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Heading_ItalicInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_heading_italic(inputs)
	return en_faq_heading_italic(inputs)
});